import React, { useState } from "react";
import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../Icons/CreateIcon";
import { useParams } from "react-router-dom";
import useGetHook from "../customHooks/useGetHook";
import APIS from "../constant/Endpoint";
import Spinner from "../components/Reusable/Spinner";
import usePostHook from "../customHooks/usePostHook";
import usePatchHook from "../customHooks/usePatchHook";
const EditTemplateComponent = loadable(
  () => import("../components/Temaplate/EditTemplate")
);
const EditTemplate = () => {
  const { id } = useParams();
  const [isopenWarningPopup, setIsOpenWarningPopup] = useState(false);
  const { data: templateData, isLoading } = useGetHook({
    queryKey: [`template-${id}`],
    url: `${APIS.TEMPLATE}${id}/`,
    params: {},
  });
  const { mutateAsync: Resetmutateasync, isPostLoading } = usePostHook({
    queryKey: ["reset"],
  });
  const { mutateAsync, isLoading: isPatchloading } = usePatchHook({
    queryKey: [`template-${id}`],
    // navigateURL:"/templatelist"
  });
  const handleReset = async () => {
    let formData = {};
    const url = `${APIS.TEMPLATE}${id}/reset-to-default/`;
    try {
      const res = await Resetmutateasync({ url, formData });
      if (res?.status === 200) {
        setIsOpenWarningPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleEdit = async (values: any, setError: any) => {
    let formData = {
      ...values,
    };
    const url = `${APIS.TEMPLATE}${id}/`;
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Template
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditTemplateComponent
          templateData={templateData}
          handleEdit={handleEdit}
          handleReset={handleReset}
          setIsOpenWarningPopup={setIsOpenWarningPopup}
          isopenWarningPopup={isopenWarningPopup}
          isPatchLoading={isPatchloading}
        />
      )}
    </>
  );
};

export default EditTemplate;
